<template>
    <div class="poster-dom-c">
        <header>
            <img src="//statics.itc.cn/mp/article-page/wap/prod/images/logo-1d7370.png"/>
            <span>手机搜狐网 <span class="domain">m.sohu.com</span></span>
            <span class="date">{{date}}</span>
        </header>
        <section>
            <p class="title">{{articleTitle}}</p>
            <!-- 长图处理 -->
            <div class="long-cover-img" v-if="isLongPic && articleCover">
                <img :src="articleCover"/>
            </div>
            <!-- 非长图 -->
            <img v-if="articleCover && !isLongPic" :src="articleCover" class="cover-img"/>
            
            <p v-if="articleExcerpt" class="article-excerpt">{{articleExcerpt}}</p>
            <!-- 作者信息 -->
            <div class="author-c">
                <img v-if="articleAuthorAvatar" :src="articleAuthorAvatar"/>
                <span v-if="articleAuthorName">{{articleAuthorName}}</span>
            </div>
            <footer>
                <div class="left">
                    <span>长按识别二维码，阅读全文</span>
                    <img src="../../less/images/share_poster_logo_sohu@2x.png"/>
                </div>
                <div id="qrCode" class="qr-code"></div>
            </footer>
        </section>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'

export default {
    components: {
    },
    data () {
        return {
            date: '',
            isLongPic: false,
            articleTitle: window.cfgs?.articleTitle || '',
            articleCover: window.cfgs?.cover || '',
            articleImgList: window.cfgs?.imageList || '',
            articleExcerpt: window.cfgs?.excerpt || '',
            articleAuthorAvatar: window.cfgs?.authorAvatar || '',
            articleAuthorName: window.cfgs?.authorName || '',
        }
    },
    methods: {
        init() {
            for( let i = 0; i < this.articleImgList.length; i++) {
                let item = this.articleImgList[i]
                if(item.url.indexOf(this.articleCover) > -1) {
                    this.isLongPic = item.width * 1 < item.height * 1
                    break
                }
            }
         },
        getDate() {
            let date = new Date()
            let month = date.getMonth() + 1
            let day = date.getDate()
            month = (month > 9) ? month : ("0" + month)
            day = (day < 10) ? ("0" + day) : day
            this.date = month + '/' + day
         },
        createQrCode() {
            const el = document.getElementById("qrCode")
            new QRCode(el, {
                text: window.location.origin + window.location.pathname + '?_trans_=010006_fxhbzdewm', // 需要转换为二维码的内容
                width: 156,
                height: 156,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
        },
    },
    mounted() {
        this.init()
        this.getDate()
        this.createQrCode()
    }
    
}
</script>
<style lang="less" scoped>
    .poster-dom-c {
        width: 750px;/*px*/
        padding: 40px 36px;/*px*/
        box-sizing: border-box;
        background: linear-gradient(to bottom,#FFC326 0%,#171717 40%, #171717);
        header {
            display: flex;
            font-size: 30px;/*px*/
            font-weight: 500;
            color: #FFFFFF;
            align-items: center;
            margin-bottom: 32px;/*px*/
            .domain {
                font-weight: normal;
            }
            img {
                width: 48px;/*px*/
                height: 48px;/*px*/
                border-radius: 9px;/*px*/
                margin-right: 16px;/*px*/
            }
            .date {
                margin-left: auto;
                font-size: 28px;/*px*/
                font-family: DINPro-Regular, DINPro;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 36px;/*px*/
            }
        }
        section {
            width: 678px;/*px*/
            box-sizing: border-box;
            background: #FFFFFF;
            border-radius: 12px;/*px*/
            padding: 40px 32px;/*px*/
            .title {
                font-size: 48px;/*px*/
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #111111;
                line-height: 64px;/*px*/
            }
            .long-cover-img {
                margin-top: 24px;/*px*/
                width: 612px;/*px*/
                height: 612px;/*px*/
                overflow: hidden;
                position: relative;
                img {
                    width: 612px;/*px*/
                    position: absolute;
                    left: 0;
                    top: 0;
                }
            }
            .cover-img {
                margin-top: 24px;/*px*/
                width: 612px;/*px*/
            }
            .article-excerpt {
                margin-top: 28px;/*px*/
                font-size: 36px;/*px*/
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 54px;/*px*/
                margin-bottom: 32px;/*px*/
            }
            .author-c {
                display: flex;
                height: 42px;/*px*/
                align-items: center;
                font-size: 24px;/*px*/
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #A2A2A3;
                margin-bottom: 28px;/*px*/
                img {
                    width: 42px;/*px*/
                    height: 42px;/*px*/
                    border-radius: 50%;
                    margin-right: 12px;/*px*/
                    border: 0.5px rgba(0, 0, 0, 0.1) solid;/*px*/
                }
            }
            footer {
                border-top: 2px solid #EBEBEB;/*px*/
                padding-top: 32px;/*px*/
                display: flex;
                justify-content: space-between;
                .left {
                    display: flex;
                    flex-direction: column;
                    padding-top: 22px;/*px*/
                    box-sizing: border-box;
                    span {
                        height: 40px;/*px*/
                        font-size: 28px;/*px*/
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #333333;
                        line-height: 40px;/*px*/
                    }
                    img {
                        margin-top: 24px;/*px*/
                        width: 120px;/*px*/
                    }
                }
                /deep/ .qr-code {
                    width: 156px;/*px*/
                    height: 156px;/*px*/
                    padding: 4px;/*px*/
                    canvas {
                        width: 156px;/*px*/
                        height: 156px;/*px*/
                    }
                }
            }
        }
    }

</style>